// ** Icon Imports
import { Icon as IconifyIcon } from '@iconify/react'

const Icon = ({ icon, ...rest }) => {
  return <IconifyIcon icon={icon} fontSize='1.375rem' {...rest} />
}

export default Icon
